import PersonalInformationEditWrapper from './PersonalInformationEditWrapper.component';

export default PersonalInformationEditWrapper;